module.exports = "/1700049123/static/img/label.svg";